module.exports = __webpack_public_path__ + "images/etiquete_vegan-10168154b011a01ff2751d3adbda0777.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/etiquete_vegan.svg
// module id = 54
// module chunks = 0 1